var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobilePlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "427px",
    height: "426px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.513
    },
    fill: "#020202",
    d: "M 263.5,34.5 C 263.5,35.1667 263.5,35.8333 263.5,36.5C 263.167,36.5 262.833,36.5 262.5,36.5C 262.573,34.9731 261.906,33.9731 260.5,33.5C 256.032,28.0512 250.699,27.0512 244.5,30.5C 241.098,30.3424 237.764,30.6758 234.5,31.5C 234.5,31.1667 234.5,30.8333 234.5,30.5C 241.633,28.0499 248.966,26.8832 256.5,27C 259.739,28.7364 262.073,31.2364 263.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.877
    },
    fill: "#fcfcfc",
    d: "M 232.5,30.5 C 207.07,36.9898 181.404,42.9898 155.5,48.5C 179.805,37.0083 205.471,31.0083 232.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#fcfcfc",
    d: "M 244.5,30.5 C 249.801,31.4968 255.134,32.4968 260.5,33.5C 261.906,33.9731 262.573,34.9731 262.5,36.5C 286.482,139.096 310.149,241.763 333.5,344.5C 333.267,346.062 332.6,347.395 331.5,348.5C 330.833,348.5 330.5,348.833 330.5,349.5C 329.833,349.5 329.5,349.833 329.5,350.5C 328.508,350.328 327.842,350.662 327.5,351.5C 326.833,351.5 326.5,351.833 326.5,352.5C 324.167,353.167 321.833,353.833 319.5,354.5C 275.816,364.504 232.15,374.671 188.5,385C 184.56,386.015 180.56,386.515 176.5,386.5C 172.98,385.817 170.48,383.817 169,380.5C 149.339,296.855 129.839,213.189 110.5,129.5C 110.672,128.508 110.338,127.842 109.5,127.5C 108.243,121.546 107.243,115.546 106.5,109.5C 108.112,105.942 109.445,102.275 110.5,98.5C 132.297,189.631 153.797,280.965 175,372.5C 175.708,373.381 176.542,374.047 177.5,374.5C 175.981,369.752 174.648,364.919 173.5,360C 173.905,359.055 174.572,358.388 175.5,358C 223.057,347.069 270.557,335.902 318,324.5C 318.945,324.905 319.612,325.572 320,326.5C 321.476,331.406 322.476,336.406 323,341.5C 323.667,338.5 323.667,335.5 323,332.5C 300.922,236.92 278.422,141.587 255.5,46.5C 255.288,43.2876 253.621,41.2876 250.5,40.5C 250.389,39.8826 250.056,39.3826 249.5,39C 247.167,38.3333 244.833,38.3333 242.5,39C 230.494,41.8348 218.494,44.6681 206.5,47.5C 206.247,44.5212 206.913,41.5212 208.5,38.5C 217.185,36.1624 225.852,33.8291 234.5,31.5C 237.764,30.6758 241.098,30.3424 244.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#fefefe",
    d: "M 263.5,34.5 C 288.904,41.7001 311.571,53.8667 331.5,71C 359.317,95.8032 380.483,125.303 395,159.5C 407.491,208.577 401.824,255.577 378,300.5C 367.699,319.633 353.199,334.633 334.5,345.5C 334.5,345.167 334.5,344.833 334.5,344.5C 334.664,341.813 334.497,339.146 334,336.5C 310.781,236.297 287.281,136.297 263.5,36.5C 263.5,35.8333 263.5,35.1667 263.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#fbfcfc",
    d: "M 250.5,40.5 C 252.196,42.5248 253.863,44.5248 255.5,46.5C 255.318,48.5914 255.652,50.5914 256.5,52.5C 209.383,64.4592 162.05,75.7925 114.5,86.5C 116.442,79.9486 119.442,73.9486 123.5,68.5C 124.391,67.8902 125.391,67.5569 126.5,67.5C 162.844,59.1644 199.177,50.6644 235.5,42C 240.434,40.8399 245.434,40.3399 250.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e5d5d",
    d: "M 250.5,40.5 C 253.621,41.2876 255.288,43.2876 255.5,46.5C 253.863,44.5248 252.196,42.5248 250.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6969",
    d: "M 237.5,46.5 C 240.32,46.2475 242.986,46.7475 245.5,48C 247.028,50.8808 246.362,53.2141 243.5,55C 238.88,56.3267 234.213,56.9934 229.5,57C 228.158,54.985 227.658,52.8183 228,50.5C 230.968,48.4889 234.134,47.1556 237.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f6e6e",
    d: "M 232.5,30.5 C 233.167,30.5 233.833,30.5 234.5,30.5C 234.5,30.8333 234.5,31.1667 234.5,31.5C 225.852,33.8291 217.185,36.1624 208.5,38.5C 206.913,41.5212 206.247,44.5212 206.5,47.5C 218.494,44.6681 230.494,41.8348 242.5,39C 244.833,38.3333 247.167,38.3333 249.5,39C 250.056,39.3826 250.389,39.8826 250.5,40.5C 245.434,40.3399 240.434,40.8399 235.5,42C 199.177,50.6644 162.844,59.1644 126.5,67.5C 126.5,66.8333 126.5,66.1667 126.5,65.5C 126.833,65.5 127.167,65.5 127.5,65.5C 135.949,63.9712 144.282,61.9712 152.5,59.5C 150.81,57.4807 149.144,55.4807 147.5,53.5C 147.328,52.5084 147.662,51.8417 148.5,51.5C 150.108,54.9435 152.608,57.6102 156,59.5C 171.771,55.4124 187.605,51.579 203.5,48C 205.37,44.9393 206.037,41.7726 205.5,38.5C 187.195,42.993 168.862,47.3263 150.5,51.5C 150.833,50.8333 151.167,50.1667 151.5,49.5C 152.833,49.1667 154.167,48.8333 155.5,48.5C 181.404,42.9898 207.07,36.9898 232.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f5f7",
    d: "M 148.5,51.5 C 149.167,51.5 149.833,51.5 150.5,51.5C 168.862,47.3263 187.195,42.993 205.5,38.5C 206.037,41.7726 205.37,44.9393 203.5,48C 187.605,51.579 171.771,55.4124 156,59.5C 152.608,57.6102 150.108,54.9435 148.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfe9ed",
    d: "M 239.5,47.5 C 243.395,47.8573 244.395,49.8573 242.5,53.5C 238.36,55.2562 234.193,55.9229 230,55.5C 229.257,53.5594 229.424,51.7261 230.5,50C 233.742,49.5939 236.742,48.7605 239.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.913
    },
    fill: "#fcfcfc",
    d: "M 147.5,53.5 C 149.144,55.4807 150.81,57.4807 152.5,59.5C 144.282,61.9712 135.949,63.9712 127.5,65.5C 131.593,61.0706 136.259,57.404 141.5,54.5C 142.492,54.6716 143.158,54.3382 143.5,53.5C 144.964,52.5946 146.298,52.5946 147.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 111.5,95.5 C 111.5,94.8333 111.5,94.1667 111.5,93.5C 112.309,91.9724 112.976,90.3057 113.5,88.5C 161.337,76.8745 209.337,65.8745 257.5,55.5C 277.4,144.666 298.067,233.666 319.5,322.5C 270.849,334.164 222.182,345.831 173.5,357.5C 152.688,270.084 132.021,182.751 111.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cddde3",
    d: "M 104.5,110.5 C 105.521,117.038 107.188,122.705 109.5,127.5C 110.338,127.842 110.672,128.508 110.5,129.5C 109.876,129.917 109.543,130.584 109.5,131.5C 128.763,215.654 148.597,299.654 169,383.5C 170.731,385.617 172.898,387.117 175.5,388C 173.292,388.191 171.292,388.691 169.5,389.5C 166.085,388.805 163.418,387.138 161.5,384.5C 140.961,296.685 120.295,209.018 99.5,121.5C 95.8295,105.157 92.3295,88.8241 89,72.5C 90.824,67.3202 94.324,64.4869 99.5,64C 97.1465,66.133 96.1465,68.7997 96.5,72C 99.0897,84.8574 101.756,97.6908 104.5,110.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.635
    },
    fill: "#1a1a19",
    d: "M 151.5,49.5 C 151.167,50.1667 150.833,50.8333 150.5,51.5C 149.833,51.5 149.167,51.5 148.5,51.5C 147.662,51.8417 147.328,52.5084 147.5,53.5C 146.298,52.5946 144.964,52.5946 143.5,53.5C 142.508,53.3284 141.842,53.6618 141.5,54.5C 129.811,56.8047 118.144,59.3047 106.5,62C 100.825,63.1771 97.8248,66.6771 97.5,72.5C 100.329,84.8127 102.995,97.146 105.5,109.5C 105.5,110.167 105.167,110.5 104.5,110.5C 101.756,97.6908 99.0897,84.8574 96.5,72C 96.1465,68.7997 97.1465,66.133 99.5,64C 94.324,64.4869 90.824,67.3202 89,72.5C 92.3295,88.8241 95.8295,105.157 99.5,121.5C 99.1667,121.5 98.8333,121.5 98.5,121.5C 98.5,120.833 98.1667,120.5 97.5,120.5C 94.297,105.153 90.9637,89.8196 87.5,74.5C 88.5047,67.9951 92.1713,63.8284 98.5,62C 116.221,57.9861 133.888,53.8195 151.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.551
    },
    fill: "#000000",
    d: "M 126.5,65.5 C 126.5,66.1667 126.5,66.8333 126.5,67.5C 125.391,67.5569 124.391,67.8902 123.5,68.5C 111.419,69.058 106.919,75.058 110,86.5C 110.986,87.1712 112.153,87.1712 113.5,86.5C 113.5,87.1667 113.5,87.8333 113.5,88.5C 110.266,89.0056 109.599,90.6722 111.5,93.5C 111.5,94.1667 111.5,94.8333 111.5,95.5C 111.672,96.4916 111.338,97.1583 110.5,97.5C 109.171,91.5169 107.838,85.5169 106.5,79.5C 106.631,74.5351 108.964,71.0351 113.5,69C 117.912,67.9811 122.245,66.8145 126.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747473",
    d: "M 262.5,36.5 C 262.833,36.5 263.167,36.5 263.5,36.5C 287.281,136.297 310.781,236.297 334,336.5C 334.497,339.146 334.664,341.813 334.5,344.5C 334.167,344.5 333.833,344.5 333.5,344.5C 310.149,241.763 286.482,139.096 262.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.475
    },
    fill: "#000000",
    d: "M 73.5,112.5 C 75.8741,114.401 76.0407,116.735 74,119.5C 73.5034,117.19 73.3367,114.857 73.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.496
    },
    fill: "#000000",
    d: "M 65.5,119.5 C 67.9892,119.298 70.3225,119.798 72.5,121C 71.3333,121.167 70.1667,121.333 69,121.5C 67.3189,121.392 66.1522,120.725 65.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.473
    },
    fill: "#000000",
    d: "M 74.5,122.5 C 76.4827,120.022 78.816,119.855 81.5,122C 79.1902,122.497 76.8568,122.663 74.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#fefefe",
    d: "M 97.5,120.5 C 98.1667,120.5 98.5,120.833 98.5,121.5C 118.681,208.892 139.181,296.226 160,383.5C 160.383,384.056 160.883,384.389 161.5,384.5C 163.418,387.138 166.085,388.805 169.5,389.5C 172.881,389.54 176.214,389.207 179.5,388.5C 225.723,377.361 272.056,366.694 318.5,356.5C 271.209,387.071 219.543,398.904 163.5,392C 125.951,385.644 93.7845,369.144 67,342.5C 31.5703,297.115 18.9036,246.115 29,189.5C 35.7184,174.714 44.885,161.714 56.5,150.5C 56.2322,152.099 56.5655,153.432 57.5,154.5C 58.8786,156.597 60.5453,156.93 62.5,155.5C 64.2926,155.116 65.2926,153.95 65.5,152C 65.3613,150.699 64.6946,149.866 63.5,149.5C 62.713,147.896 61.3797,147.229 59.5,147.5C 72.1291,138.512 84.7957,129.512 97.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#696a6a",
    d: "M 105.5,109.5 C 105.833,109.5 106.167,109.5 106.5,109.5C 107.243,115.546 108.243,121.546 109.5,127.5C 107.188,122.705 105.521,117.038 104.5,110.5C 105.167,110.5 105.5,110.167 105.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.473
    },
    fill: "#000000",
    d: "M 74.5,122.5 C 74.6104,125.059 73.9438,127.392 72.5,129.5C 71.8338,128.169 71.8338,126.669 72.5,125C 72.6842,123.624 73.3509,122.791 74.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f1f1",
    d: "M 63.5,149.5 C 63.6747,151.621 63.3414,153.621 62.5,155.5C 60.7839,155.371 59.1172,155.038 57.5,154.5C 56.9377,149.467 58.9377,147.801 63.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#333333",
    d: "M 59.5,147.5 C 61.3797,147.229 62.713,147.896 63.5,149.5C 58.9377,147.801 56.9377,149.467 57.5,154.5C 56.5655,153.432 56.2322,152.099 56.5,150.5C 56.5,148.5 57.5,147.5 59.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7d7d7c",
    d: "M 63.5,149.5 C 64.6946,149.866 65.3613,150.699 65.5,152C 65.2926,153.95 64.2926,155.116 62.5,155.5C 63.3414,153.621 63.6747,151.621 63.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1d1d0",
    d: "M 83.5,151.5 C 84.8333,151.5 86.1667,151.5 87.5,151.5C 87.5,152.833 87.5,154.167 87.5,155.5C 86.1667,155.5 84.8333,155.5 83.5,155.5C 82.1667,154.167 82.1667,152.833 83.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#696868",
    d: "M 83.5,151.5 C 86.0799,149.992 88.0799,150.659 89.5,153.5C 88.0799,156.341 86.0799,157.008 83.5,155.5C 84.8333,155.5 86.1667,155.5 87.5,155.5C 87.5,154.167 87.5,152.833 87.5,151.5C 86.1667,151.5 84.8333,151.5 83.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464645",
    d: "M 57.5,154.5 C 59.1172,155.038 60.7839,155.371 62.5,155.5C 60.5453,156.93 58.8786,156.597 57.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575757",
    d: "M 110.5,129.5 C 129.839,213.189 149.339,296.855 169,380.5C 170.48,383.817 172.98,385.817 176.5,386.5C 177.5,387.167 178.5,387.833 179.5,388.5C 176.214,389.207 172.881,389.54 169.5,389.5C 171.292,388.691 173.292,388.191 175.5,388C 172.898,387.117 170.731,385.617 169,383.5C 148.597,299.654 128.763,215.654 109.5,131.5C 109.543,130.584 109.876,129.917 110.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727271",
    d: "M 255.5,46.5 C 278.422,141.587 300.922,236.92 323,332.5C 323.667,335.5 323.667,338.5 323,341.5C 322.476,336.406 321.476,331.406 320,326.5C 319.612,325.572 318.945,324.905 318,324.5C 270.557,335.902 223.057,347.069 175.5,358C 174.572,358.388 173.905,359.055 173.5,360C 174.648,364.919 175.981,369.752 177.5,374.5C 176.542,374.047 175.708,373.381 175,372.5C 153.797,280.965 132.297,189.631 110.5,98.5C 110.5,98.1667 110.5,97.8333 110.5,97.5C 111.338,97.1583 111.672,96.4916 111.5,95.5C 132.021,182.751 152.688,270.084 173.5,357.5C 222.182,345.831 270.849,334.164 319.5,322.5C 298.067,233.666 277.4,144.666 257.5,55.5C 209.337,65.8745 161.337,76.8745 113.5,88.5C 113.5,87.8333 113.5,87.1667 113.5,86.5C 113.833,86.5 114.167,86.5 114.5,86.5C 162.05,75.7925 209.383,64.4592 256.5,52.5C 255.652,50.5914 255.318,48.5914 255.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3e2e9",
    d: "M 169.5,216.5 C 171.124,216.36 172.29,217.027 173,218.5C 175.813,228.718 177.98,239.051 179.5,249.5C 175.044,249.965 170.711,250.965 166.5,252.5C 165.808,251.975 165.308,251.308 165,250.5C 163.071,240.949 160.904,231.449 158.5,222C 158.585,220.893 158.919,219.893 159.5,219C 163.09,218.689 166.423,217.856 169.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 189.5,197.5 C 190.833,197.5 192.167,197.5 193.5,197.5C 196.21,212.3 199.543,226.966 203.5,241.5C 203.392,242.442 203.059,243.275 202.5,244C 197.82,244.837 193.154,245.671 188.5,246.5C 185.722,231.553 182.389,216.72 178.5,202C 178.905,201.055 179.572,200.388 180.5,200C 183.742,199.594 186.742,198.761 189.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 207.5,173.5 C 210.238,172.965 212.072,173.965 213,176.5C 218.039,197.073 222.539,217.739 226.5,238.5C 221.534,239.627 216.534,240.627 211.5,241.5C 207.051,219.477 202.384,197.477 197.5,175.5C 201.078,175.451 204.411,174.785 207.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 229.5,156.5 C 230.833,156.5 232.167,156.5 233.5,156.5C 238.296,181.52 243.963,206.353 250.5,231C 250.355,231.772 250.022,232.439 249.5,233C 245.649,233.754 241.816,234.588 238,235.5C 236.674,235.245 235.674,234.578 235,233.5C 229.815,209.428 224.315,185.428 218.5,161.5C 218.818,160.353 219.484,159.519 220.5,159C 223.742,158.594 226.742,157.761 229.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 251.5,144.5 C 254.346,144.809 255.846,146.475 256,149.5C 261.942,175.489 267.775,201.489 273.5,227.5C 268.473,228.372 263.473,229.372 258.5,230.5C 252.656,202.792 246.656,175.125 240.5,147.5C 244.479,147.258 248.146,146.258 251.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b6c6d",
    d: "M 98.5,121.5 C 98.8333,121.5 99.1667,121.5 99.5,121.5C 120.295,209.018 140.961,296.685 161.5,384.5C 160.883,384.389 160.383,384.056 160,383.5C 139.181,296.226 118.681,208.892 98.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#656564",
    d: "M 318.5,346.5 C 319.122,345.373 319.955,344.373 321,343.5C 321.519,345.489 320.686,346.489 318.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.555
    },
    fill: "#0d0d0d",
    d: "M 333.5,344.5 C 333.833,344.5 334.167,344.5 334.5,344.5C 334.5,344.833 334.5,345.167 334.5,345.5C 334.451,348.099 333.451,350.266 331.5,352C 327.813,354.285 323.813,355.452 319.5,355.5C 319.5,355.167 319.5,354.833 319.5,354.5C 321.833,353.833 324.167,353.167 326.5,352.5C 327.167,352.5 327.5,352.167 327.5,351.5C 328.492,351.672 329.158,351.338 329.5,350.5C 330.167,350.5 330.5,350.167 330.5,349.5C 331.167,349.5 331.5,349.167 331.5,348.5C 332.6,347.395 333.267,346.062 333.5,344.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4e3ea",
    d: "M 220.5,351.5 C 221.5,351.5 222.5,351.5 223.5,351.5C 224.221,354.817 224.388,358.151 224,361.5C 221.049,363.076 217.883,363.743 214.5,363.5C 213.793,360.214 213.46,356.881 213.5,353.5C 216.152,353.59 218.485,352.924 220.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f6f6e",
    d: "M 318.5,346.5 C 314.154,348.595 309.487,350.095 304.5,351C 265.833,360 227.167,369 188.5,378C 183.838,379.337 180.171,378.17 177.5,374.5C 179.817,375.907 182.317,376.907 185,377.5C 229.437,366.846 273.937,356.513 318.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727271",
    d: "M 319.5,354.5 C 319.5,354.833 319.5,355.167 319.5,355.5C 319.5,356.167 319.167,356.5 318.5,356.5C 272.056,366.694 225.723,377.361 179.5,388.5C 178.5,387.833 177.5,387.167 176.5,386.5C 180.56,386.515 184.56,386.015 188.5,385C 232.15,374.671 275.816,364.504 319.5,354.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePlan);
export default __webpack_public_path__ + "static/media/mobile-plan.45fcf6b9eac5bb8fe6bbeb3422590de5.svg";
export { ForwardRef as ReactComponent };